<template>    
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container d-flex flex-column bg-documentGray">
                <header class="mdc-top-app-bar position-static">
                    <div class="mdc-top-app-bar__row">
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                            <a class="material-icons mdc-top-app-bar__navigation-icon" @click="closeExamTake()">close</a>
                        </section>
                        
                        <section class="mdc-top-app-bar__section title">
                            <div class="mdc-top-app-bar__title">
                                {{$t('1371')}}
                                <!-- Result -->
                            </div>                
                        </section>

                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                            <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                        </section>
                    </div>
                    
                </header>
                
                <section class="flex-grow-1 scroll-y exam-view-detail">
                    <div class="t-center mgr-16 mgl-16">
                        <div class="mgr-80 mgl-80">
                            <img src="@/images/exam-complete.png">
                        </div>
                        <div class="t-headline3 mgt-9">
                            {{$t('1372')}}
                            <!-- Completed -->
                        </div>

                        <div class="mgt-7 t-body3 t-center">
                            {{$t('1373')}}<br>
                            {{$t('1374')}}
                            <!-- Thank you for taking the exam.<br>
                            Check your grades and rewards! -->
                        </div>
                        
                    </div>
                    <hr class="divider mgt-20">
                    <div class="pda-default">
                        <div class="t-subtitle2 mgt-10">
                            {{$t('1375')}}
                            <!-- Scoring result -->
                        </div>
                        <div class="d-grid mgt-10">
                            <div class="mdc-card mdc-elevation--z3 grid-row-1">
                                <div class="text-center pda-default">
                                    <div class="t-headline9">
                                        {{countTotal}}
                                    </div>
                                    <div class="t-body3 t-color-bodyGrayA mgt-21">
                                        {{$t('1376')}}
                                        <!-- Test Questions -->
                                    </div>

                                </div>
                            </div>

                            <div class="mdc-card mdc-elevation--z3 grid-row-1">
                                <div class="text-center pda-default">
                                    <div class="t-headline9">
                                        {{countCorrect}}
                                    </div>
                                    <div class="t-body3 t-color-bodyGrayA mgt-21">
                                        {{$t('1377')}}
                                        <!-- Number of correct -->
                                    </div>
                                </div>
                            </div>

                            <div class="mdc-card mdc-elevation--z3 grid-row-1">
                                <div class="text-center pda-default">
                                    <div class="t-headline9">
                                        {{countIncorrect}}
                                    </div>
                                    <div class="t-body3 t-color-bodyGrayA mgt-21">
                                        {{$t('1378')}}
                                        <!-- Number of incorrect -->
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mgt-16">
                            <div class="mdc-card mdc-elevation--z2">
                                <div class="flex-row t-color-bodyGrayA d-flex justify-content-between align-items-center">
                                    <div class="mgr-16 mgl-16">
                                        {{$t('1379')}}
                                        <!-- View results by question -->
                                    </div>
                                    <div>
                                        <button class="mdc-icon-button material-icons mdc-card__action mdc-card__action--icon--unbounded" @click="toggleQuestionViewStatus()">
                                            {{questionViewStatus ? 'expand_less' : 'expand_more'}}
                                        </button>
                                    </div>
                                </div>
                                <div class="mgr-16 mgl-16 pdb-10 d-grid-5 t-color-disableBtn" v-show="questionViewStatus">
                                    <div class="t-subtitle2 item t-center pdt-16 pdb-16 position-relative" v-for="(question, index) in questions" :key="index">
                                        <div class="question-correct" :class="question.correct === true ? 'question-correct' : 'question-incorrect'"></div>
                                        {{index+1}}
                                    </div>
                                </div>
                            </div>
                            
                        </div>

                        <div class="mdc-card mdc-elevation--z3 mgt-16 learn-card-more" >
                            <div class=" pdl-8 pdr-8 pdt-21 pdb-40">
                                <div class="d-flex align-items-center">
                                    <div class="w-40 mgr-8 mgl-8 t-helper exam-my">
                                        {{$t('1380')}}
                                        <!-- My -->
                                    </div>
                                    <div class="flex-grow-1 position-relative">
                                        <div class="standard-line" :style="`left:${standard}%;`"></div>
                                        <div class="t-helper standard-text t-color-gray3" 
                                            :style="`left:calc(${standard}% - 50%);`">
                                            {{$t('92', {str: standard})}}
                                            <!-- 기준 {{learnProgressRate.course.standard}}% -->
                                        </div>
                                        <div class="progress-container">
                                            <div class="progressbar exam-my" :style="`width:${scoreMy}%;`"></div>
                                        </div>
                                    </div>
                                    <div class="flex-row-reverse d-flex mgr-8 mgl-8 t-subtitle1 w-50 exam-my">
                                        {{$t('91', {str: parseInt(scoreMy)})}}
                                    </div>
                                </div>

                                <div class="d-flex align-items-center mgt-8">
                                    <div class="w-40 mgr-8 mgl-8 t-helper t-color-gray3">
                                        {{$t('1382')}}
                                        <!-- Other -->
                                    </div>
                                    <div class="flex-grow-1">
                                        <div class="progress-container">
                                            <div class="progressbar" :style="`width:${averageScore}%;`"></div>
                                        </div>
                                    </div>
                                    <div class="flex-row-reverse d-flex mgr-8 mgl-8 t-subtitle2 w-50 t-color-gray3">
                                        {{$t('91', {str: averageScore ? parseInt(averageScore) : 0})}}
                                    </div>
                                </div>
                                
                                
                                
                            </div>
                        </div>

                        <div v-if="getTotalPoint == 0" class="mgt-30">
                            <div class="t-subtitle2">
                                {{$t('1385')}}
                                <!-- Rewards -->
                            </div>
                            <div class="mdc-card mdc-elevation--z2 pda-default mgt-10">
                                <div class="flex-row d-flex justify-content-between align-items-center">
                                    <div class="t-body3 t-color-bodyGrayA">
                                        {{$t('1386')}}
                                        <!-- Total points earned -->
                                    </div>
                                    <div>
                                        <!-- <span class="t-subtitle2"></span> -->
                                        <span class="t-body3">
                                            {{$t('1387', {str: getTotalPoint})}}
                                            <!-- Point -->
                                        </span>
                                    </div>
                                </div>
                                
                                
                            </div>
                        </div>

                    </div>
                </section>
                <section class="pdb-34 pdl-16 pdr-16">
                    <div v-for="(action, index) in examActions" :key="index">
                        <button class="w-full mdc-button mdc-button--raised btn-red mgt-16" :disabled="setButtonDisabled(action)" @click="examAction(action)">
                            {{setButtonActionName(action)}}
                        </button>    
                    </div>
                </section>
            </div>
        </div>
    </div>
    
</template>


<script>
/**
 * 시험 결과 컴포넌트(exam result component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import examApi from '@/api/examApi.js'
import {examMixin} from '@/mixins/exam.js'

export default {
    data() {
        return {
            countTotal: 0,
            countCorrect: 0,
            countIncorrect: 0,
            scoreMy: 0,
            questions: null,

            questionViewStatus: true,

            examActions: [],
            paperId: 0,

            scoreData: null,
            averageScore: 0,
            standard: 0,

            applicationEarnPoint: 0,
            solveAllEarnPoint: 0,
            getTotalPoint: 0,

        }
    },
    components: {
        
    },
    mixins: [examMixin],
    mounted() {
        
        let responseData = null
        let params = {
            examineeId: this.$route.params.examineeId
        }

        // 시험 응시 기록 조회(get exam submited list)
        examApi.submitedList(params).then((response) => {
            responseData = response.data.data
            
            // 마지막 응시 기록(get last submited data)
            let lastSubmitData = _.head(responseData)
            
            this.paperId = lastSubmitData.id

            params = {
                examineeId: this.$route.params.examineeId,
                paperId: this.paperId
            }

            // 응시 결과 조회(get exam result)
            examApi.result(params).then((response) => {
                responseData = response.data.data
                // console.log('result responseData', responseData)
                this.countTotal = responseData.count.total
                this.countCorrect = responseData.count.correct
                this.countIncorrect = responseData.count.incorrect

                this.applicationEarnPoint = responseData.applicationEarnPoint
                this.solveAllEarnPoint = responseData.solveAllEarnPoint
                this.getTotalPoint = this.applicationEarnPoint + this.solveAllEarnPoint

                this.scoreMy = responseData.score

                this.questions = _.chain(responseData.groups)
                    .map((item) => {
                        return item.questions
                    })
                    .flatten()
                    .map((question, index) => {
                        return question
                    }).value()

            }).catch((err) => {})

            // 시험 점수 정보(get exam score data)
            examApi.score(params).then((response) => {
                this.scoreData = response.data.data
                this.averageScore = parseInt(this.scoreData.averageScore)
                this.standard = parseInt(this.scoreData.standard)
            }).catch((err) => {})
            
            // 시험 인트로 정보(get exam intro information)
            examApi.examIntro(params).then((response) => {
                this.examData = response.data.data
                // console.log('examIntro', this.examData)
                this.examActions = this.examData.actions
            }).catch((err) => {})
        }).catch((err) => {})
    },

    methods: {
        // 시험 응시 종료 팝업(take exam close popup)
        closeExamTake() {
            this.$confirm({
                //title: this.$t('TODO-시험을 종료하시겠습니까?'),
                content: this.$t('50022'),  //시험 피드백 보기를 종료하시겠습니까?
                accept:  this.$t('50023'),  // 확인
                cancel:  this.$t('50024'),  // 취소
            }).then(() => {
                this.$router.push({
                    name: this.$route.matched[this.$route.matched.length-2].name,
                    params: this.$route.params,
                    query: {status:this.$route.query.status,examresult:'getscore'}
                })
                //http://localhost:8080/learn/231999/finalExam/11219/result?status=LEARNING
                //this.routerGoPrev()      
            }).catch(() => {})
        },
        
        toggleQuestionViewStatus() {
            this.questionViewStatus = !this.questionViewStatus
        },

        setButtonActionName(action) {
            //before_start : ~부터 응시가능
            //can_start : 응시
            //can_re_start : 재응시
            //before_confirm : ~부터 결과확인 가능
            //open_confirm : 결과확인
            let buttonName = ''
            if (action.action === 'before_start') {
                buttonName = this.$t('50010', {str: action.data.application_start_time}) //  + '{날짜}부터 응시가능
            }else if (action.action === 'can_start') {
                buttonName = this.$t('50008') //'응시(take)
            }else if (action.action === 'can_re_start') {
                buttonName = this.$t('1390') //재응시(retake)
            }else if (action.action === 'before_confirm') {
                buttonName = this.$t('50011', {str: action.data.confirm_start_time}) // '{날짜}부터 결과확인 가능
            }else if (action.action === 'open_confirm') {
                buttonName = this.$t('1388') //'결과확인(show result)
            }
            return buttonName
        },

        setButtonDisabled(action) {
            return action.action === 'before_start' || action.action === 'before_confirm' ? true : false
        },

        examAction(action) {
            if (action.action === 'can_start' || action.action === 'can_re_start') {
                // move exam take
                this.startExam()
            }else if (action.action === 'open_confirm') {
                // move exam feedback
                this.moveExamFeedback()
                
            }
        },

    }
}
</script>